export const highestAtMost = (
  top: number,
  valueAt: (n: number) => number,
  limit: number,
): number => {
  if (valueAt(top) <= limit) return top;
  let low = 0;
  let high = top;
  while (high - low > 1) {
    const middle = Math.floor((low + high) / 2);
    if (valueAt(middle) <= limit) low = middle;
    else high = middle;
  }
  return low;
};
